import { html } from 'lit';
import { Trash2 } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-trash')
export class PdsIconTrash extends PdsIcon {
  @state()
  icon = Trash2;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
